export const IRB_FLAGS = {
    irb: {
        id: 'irb',
        value: false,
        description: 'Enables the IRB sidebar link',
        owner: 'Translation Workbench',
        name: 'Enable IRB link',
        extra: { section: 'IRB', isFirst: true, dataTestId: 'irb-flag' },
    },
};
